import { FC } from "react";
import { SearchspringProduct, SearchspringVariant } from "../lib/searchspringTypes";
import FenderProductTile, { TileVariant } from "./FenderProductTile";

interface SearchspringProductTileProps {
  context?: string;
  compareClickHandler?: (e: any) => void;
  isSelectedForCompare?: boolean;
  layout: string;
  locale: string;
  onClick?: () => void;
  product: SearchspringProduct;
  showCompare?: boolean;
  isSlicedVariant?: boolean;
  shopMarket?: string;
  region?: string;
}

const SearchspringProductTile: FC<SearchspringProductTileProps> = ({ 
  context = '', 
  compareClickHandler = () => {},
  isSelectedForCompare = false,
  layout, 
  locale, 
  onClick = () => {},
  product,
  showCompare = false,
  isSlicedVariant = true,
  shopMarket = '',
  region = ''
}) => {
  const { attributes, mappings } = product;
  const { 
    collection_name,
    handle, 
    image,
    images,
    product_type,
    product_type_unigram, 
    ss_id,
    ss_variants_data,
    tags,
    variant_id,
  } = attributes;
  const { name, price, sku } = mappings.core;
  let dataCategory = '';
  if (collection_name && collection_name.length > 0) {
    dataCategory = collection_name[0];
  }

  let variants: TileVariant[] = [];
  if (ss_variants_data) {
    const ssVariantsArray = JSON.parse(ss_variants_data);
    variants = ssVariantsArray.map((variant: SearchspringVariant) => {
      const { 
        id,
        inventory_quantity,
        mfield_custom_gbp_pricing,
        mfield_custom_dkk_pricing,
        mfield_custom_nok_pricing,
        mfield_custom_sek_pricing,
        mfield_custom_callout_message,
        mfield_custom_gone_out_of_stock,
        mfield_custom_back_in_stock,
        mfield_custom_new_variant,
        mfield_custom_product_badge_override,
        mfield_custom_product_badge,
        mfield_custom_text_badge_2,
        mfield_custom_text_badge,
        mfield_custom_variant_media,
        mfield_custom_included_in_uk_market,
        price,  
      } = variant;

      // if (shopMarket == 'gb' && mfield_custom_included_in_uk_market == "false") {
      //   return null;
      // }

      let marketPrice = price;
      if (shopMarket == 'gb' && mfield_custom_gbp_pricing) {
        marketPrice = mfield_custom_gbp_pricing;
      } else if (shopMarket == 'dk' && mfield_custom_dkk_pricing) {
        marketPrice = mfield_custom_dkk_pricing;
      } else if (shopMarket == 'no' && mfield_custom_nok_pricing) {
        marketPrice = mfield_custom_nok_pricing;
      } else if (shopMarket == 'se' && mfield_custom_sek_pricing) {
        marketPrice = mfield_custom_sek_pricing;
      }

      let pillBadgeText = '';
      if (mfield_custom_product_badge_override == "true" && mfield_custom_product_badge) {
        pillBadgeText = mfield_custom_product_badge;
      }

      let textBadges = [];
      if (mfield_custom_text_badge) {
        textBadges.push(mfield_custom_text_badge);
      }
      if (mfield_custom_text_badge_2) {
        textBadges.push(mfield_custom_text_badge_2);
      }

      let imageUrls = [];
      let swatchUrl = '';
      let swatchName = '';
      if (mfield_custom_variant_media) {
        const mediaObject = JSON.parse(mfield_custom_variant_media);
        if (mediaObject && mediaObject.variantMedia) {
          const { images, swatch } = mediaObject.variantMedia;
          // Image 1 should be the default variant image, 2 should be the back facing for hover.
          if (images && images[0]?.url) {
            imageUrls.push(images[0].url);
          }
          if (images && images[1]?.url) {
            imageUrls.push(images[1].url);
          }

          // The color swatch should be the first image in this array.
          if (swatch && swatch[0]?.url) {
            swatchUrl = swatch[0].url;
          }
          if (swatch && swatch[0]?.altText) {
            swatchName = swatch[0].altText;
          }
        }
      }

      const parsed: TileVariant = {
        id,
        calloutMessage: mfield_custom_callout_message || '',
        imageUrls,
        inventory: inventory_quantity,
        backInStockFlag: (mfield_custom_back_in_stock == "true") || false,
        outOfStockFlag: (mfield_custom_gone_out_of_stock == "true") || false,
        isNewVariant: (mfield_custom_new_variant == "true") || false,
        pillBadgeOverride: pillBadgeText,
        price: marketPrice,
        swatchName,
        swatchUrl,
        textBadges,
      }
      return parsed;
    });
  }

  let fallbackImageUrls: string[] = [];
  if (images) {
    fallbackImageUrls = images.split('|');
  } else if (image) {
    fallbackImageUrls = [image];
  }

  // The only difference when displaying sliced variants is which variant appears
  // first in the array – it should always be the "target" variant.
  if (isSlicedVariant) {
    const targetVariantIds = variant_id?.split('|') || [];
    variants.sort(v => targetVariantIds.includes(v.id) ? -1 : 0);
  }

  return (
    <FenderProductTile 
      context={context}
      compareClickHandler={compareClickHandler}
      dataCategory={dataCategory}
      fallbackImageUrls={fallbackImageUrls}
      isSelectedForCompare={isSelectedForCompare}
      layout={layout}
      locale={locale}
      onClick={onClick}
      productHandle={handle}
      productId={ss_id}
      productIsLeftHanded={(product_type_unigram?.includes('lefthand'))}
      productName={name}
      productPrice={price}
      productSku={sku}
      productTags={tags}
      productType={product_type}
      shopMarket={shopMarket}
      showCompare={showCompare}
      region={region}
      variants={variants}
    />
  );
}

export default SearchspringProductTile;